import { gql } from "@apollo/client";
import { AccountDeliveryDriverInput } from "../../types/AccountDeliveryDriverInput";
import { AccountDeliveryDriverInputType } from "../../types/AccountDeliveryDriverInputType";
import { client } from "graphql/client";

export const UPDATE_ACCOUNT_DELIVERY_DRIVER = gql`
    mutation UpdateAccountDeliveryDriver($accountId: Long!, $input: AccountDeliveryDriverInput!, $confirmed: Boolean!) {
        updateAccountDeliveryDriver(accountId: $accountId, input: $input, confirmed: $confirmed) {
            success
            requiresConfirmation
            driverTaskStatuses
            originalInput {
                email
                countryCode
                phone
                password
                name
                avatarStorageToken
                status
                vehicleTypeId
                vehiclePlate
                vehicleImageS3KeysJson
                driverLicenseNumber
                dspCode
                isOnDuty
                isBlacklist
                isEmployed
                idDocumentType
                idDocumentNumber
                idDocumentImageS3KeysJson
            }
        }
    }
`;

export interface UpdateAccountDeliveryDriverResponseType {
    success: boolean;
    requiresConfirmation: boolean;
    driverTaskStatuses: string[];
    originalInput?: AccountDeliveryDriverInputType | null;
}

export interface UpdateAccountDeliveryDriverResponse {
    updateAccountDeliveryDriver: UpdateAccountDeliveryDriverResponseType;
}

export interface UpdateAccountDeliveryDriverVariables {
    accountId: number;
    input: AccountDeliveryDriverInput;
    confirmed: boolean;
}

export const updateAccountDeliveryDriver = async (
    accountId: number,
    input: AccountDeliveryDriverInput,
    confirmed: boolean = false
): Promise<UpdateAccountDeliveryDriverResponseType> => {
    const { data } = await client.mutate<UpdateAccountDeliveryDriverResponse, UpdateAccountDeliveryDriverVariables>({
        mutation: UPDATE_ACCOUNT_DELIVERY_DRIVER,
        variables: { accountId, input, confirmed }
    });
    return data!.updateAccountDeliveryDriver;
};